export enum GeoLocationError {
    // Too low confidence in detected location
    NOT_ENOUGH_ACCURACY = 'not-enough-accuracy',
    // User is not within the defined bounds
    OUT_OF_BOUNDS = 'out-of-bounds',
    // Location spoofing detected/Location has moved in ways that is not physically possible
    POTENTIAL_SPOOFING = 'potential-spoofing',
    // Cannot verify location is in bounds as its too close to the bounds borders
    TOO_CLOSE_TO_BOUNDS = 'too-close-to-bounds',
    // GeoLocation software is out of date
    SOFTWARE_OUT_OF_DATE = 'software-out-of-date',
    // VPN/"IP Anonymizer" detected
    VPN_DETECTED = 'vpn-detected',
    // Remote desktop software has been detected on the users device
    REMOTE_DESKTOP_DETECTED = 'remote-desktop-detected',
    // Rooted/Jailbroken device has been detected
    DEVICE_TAMPERING_DETECTED = 'device-tampering-detected',
    // Proxy server has been detected
    PROXY_DETECTED = 'proxy-detected',
    // Users device time has been modified from its original
    MODIFIED_TIME_DETECTED = 'modified-time-detected',
    // Software not installed
    SOFTWARE_NOT_RUNNING = 'software-not-running',
    // Unknown error occurred.
    UNKNOWN_ERROR = 'unknown-error',
}
